export var getColumnItemWidth = function getColumnItemWidth(_ref) {
  var size = _ref.size;
  return size || 12;
};
export var getColumnSpacing = function getColumnSpacing(_ref2) {
  var spacing = _ref2.spacing;
  return spacing ? spacing : 0;
};
export var getGutterSpacing = function getGutterSpacing(_ref3) {
  var gutter = _ref3.gutter;
  return gutter ? gutter / 2 : 0;
};